export default {
	1: 'Locataire',
	2: 'Copropriétaire',
	3: 'Autre'
}